import { render, staticRenderFns } from "./UserActiveBookings.vue?vue&type=template&id=2cb0369c&"
import script from "./UserActiveBookings.vue?vue&type=script&lang=js&"
export * from "./UserActiveBookings.vue?vue&type=script&lang=js&"
import style0 from "./UserActiveBookings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports